







































import {Emit} from 'vue-property-decorator';
import {InOut} from 'vue-inout-prop-decorator';
import {Component, Vue} from '@/shared/component';

import {DevisElementsList} from '@/models';

import CrudDevisElementsListEdit from '@/components/Crud/DevisElementsList/Edit.vue';

@Component({
	components: {
		CrudDevisElementsListEdit,
	}
})
export default class CrudDevisElementsListEditDialog extends Vue {
	@InOut({ type: DevisElementsList  , isVModel: true }) private value!: DevisElementsList;
	@InOut({ type: Boolean  , isVModel: false }) private route!: Boolean;

	@Emit()
	private onSubmit(devisElementsList: DevisElementsList) {
		this.onClose();
	}

	@Emit()
	private onClose() {
		this.value = null;
	}
}
